import * as yup from 'yup';
import { expirationDateRegex, phoneRegex } from 'features/account/config/account-form.const';
import { StripeElementsOptions } from '@stripe/stripe-js';

export const ADD_DELIVERY_DEFAULT_VALUES = {
   firstName: '',
   lastName: '',
   phone: '',
   address: '',
   address2: '',
   country: '',
   city: '',
   region: '',
   postal: '',
   instructions: '',
};

export const ADD_BILLING_DEFAULT_VALUES = {
   firstName: '',
   lastName: '',
   address: '',
   address2: '',
   country: '',
   city: '',
   region: '',
   postal: '',
   expiry: '',
};

export const PICK_UP_DEFAULT_VALUES = {
   firstName: '',
   lastName: '',
   phone: '',
};

export const PICK_UP_SCHEMA = yup.object({
   firstName: yup.string().required('First name is required'),
   lastName: yup.string().required('Last name is required'),
   phone: yup.string().matches(phoneRegex, 'Invalid phone number').required('Phone number is required'),
});

export const ADD_DELIVERY_SCHEMA = yup.object({
   firstName: yup.string().required('First name is required'),
   lastName: yup.string().required('Last name is required'),
   phone: yup.string().matches(phoneRegex, 'Invalid phone number').required('Phone number is required'),
   address: yup.string().required('Address is required'),
   address2: yup.string(),
   city: yup.string().required('City is required'),
   region: yup.string().required('Region is required'),
   postal: yup.string().required('Postal code is required'),
   instructions: yup.string(),
});

export const ADD_BILLING_SCHEMA = yup.object({
   firstName: yup.string().required('First name is required'),
   lastName: yup.string().required('Last name is required'),
   address: yup.string().required('Address is required'),
   address2: yup.string(),
   city: yup.string().required('City is required'),
   country: yup.string().required('Country is required'),
   region: yup.string().required('Region is required'),
   postal: yup.string().required('Postal code is required'),
});

export const ADD_STRIPE_BILLING_SCHEMA = yup.object({
   firstName: yup.string(),
   lastName: yup.string(),
   address: yup.string(),
   address2: yup.string(),
   city: yup.string(),
   region: yup.string(),
   expiry: yup
      .string()
      .matches(expirationDateRegex, 'Invalid Expiration Date')
      .required('Expiration Date is required')
      .test('expirationDate', 'Credit card is expired', (value) => {
         if (!value) return false;
         const [month, year] = value.split('/');
         if (!month || !year) return false;
         const expMonth = parseInt(month, 10);
         const expYear = 2000 + parseInt(year, 10);
         const now = new Date();
         const currentYear = now.getFullYear();
         const currentMonth = now.getMonth() + 1;

         if (expYear > currentYear) return true;
         return expYear === currentYear && expMonth >= currentMonth;
      }),
   country: yup.string().required('Country is required'),
   postal: yup.string().required('Postal code is required'),
});

export const MISSING_PICKUP_INFO_MSG = 'Pickup information is required.';

export const stripeDefaultOptions: StripeElementsOptions = {
   mode: 'setup',
   currency: 'usd',
   appearance: {},
};
